import { Pagination } from '@/domain/models'
import { Category } from '@/domain/models/content/category'
import { ContentFormat } from '@/domain/models/content/content-format'
import { ContentSearchOrder } from '@/domain/models/content/content-search-order'
import { Subtype } from '@/domain/models/content/subtype'
import { UserContentSearchModel } from '@/domain/models/content/user-content-search-model'
import { Plan } from '@/domain/models/plan-license/plan-model'

export interface UserContentSearch {
  search(params: UserContentSearch.Params): Promise<UserContentSearch.Model>
  loader(params: UserContentSearch.Params): Promise<UserContentSearch.Model>
}

export namespace UserContentSearch {
  export const QUERY_TERM_PARAM_NAME = 'q'
  export const PLAN_PARAM_NAME = 'plan'
  export const CATEGORIES_PARAM_NAME = 'categories'
  export const FORMATS_PARAM_NAME = 'formats'
  export const INSTITUTIONS_PARAM_NAME = 'institutions'
  export const LANGUAGES_PARAM_NAME = 'languages'
  export const CAPTIONS_PARAM_NAME = 'captions'
  export const SUBTYPES_PARAM_NAME = 'subtypes'
  export const ORDER_PARAM_NAME = 'order'
  export const DEFAULT_PAGE_SIZE = 24
  export const Key = 'user-content-search'

  export type Model = UserContentSearchModel
  export interface Params extends Pagination.Params {
    queryTerm?: string | null
    plan?: Plan.Enum | null
    categories?: Category.Enum[] | null
    formats?: ContentFormat.Enum[] | null
    institutions?: number[] | null
    languages?: string[] | null
    captions?: string[] | null
    subtypes?: Subtype.Enum[] | null
    userSkillId?: number | null
    order?: ContentSearchOrder.Enum | null
  }
}
